module.exports = "### Instagram\n\n- Facebook tasked with creating new website\n\n- Built completely in React"


//////////////////
// WEBPACK FOOTER
// ./src/slides/05_history/notes_8.md
// module id = 1489
// module chunks = 0